import React from "react";

export default function Footer() {
  return (
    <div>
      <a href="https://github.com/EvaDiallo/app_weather_.git" class="repo">
        GITHUB REPOSITORY
      </a>
    </div>
  );
}
